import {useFormContext} from "react-hook-form";
import {Accordion, AccordionDetails, AccordionSummary, Grid, Typography} from "@mui/material";
import {ExpandMore} from "@mui/icons-material";
import {useTranslation} from "react-i18next";
import {FormAutocomplete, FormTextField} from "../../../common/form-fields-wrappers";
import {IRaFillingForm} from "../../../models/models";

const FinancialInfo = () => {
	const {t} = useTranslation(['network', 'translation']);

	const translatePaymentCode = (val: string) => {
		const paymentMethodsCodes = ['B', 'D', 'F', 'I', 'J', 'K', 'M', 'P', 'Q', 'R', 'S', 'T', 'X', 'Z'];
		if(paymentMethodsCodes.includes(val)) {
			return t(`raFilling.financialInfo.paymentMethods.${val}`);
		}
		return '';
	}

	const raFillingDataForm = useFormContext<IRaFillingForm>();

	return (
		<>
			<Accordion >
				<AccordionSummary expandIcon={<ExpandMore />}>
					<Typography variant={"h6"}>
						{t("raFilling.financialInfo.accordion.title")}
					</Typography>
				</AccordionSummary>

				<AccordionDetails>
					<Grid container columnSpacing={2}>
						<Grid item xs={6} md={3}>
							<FormTextField<IRaFillingForm>
								name="financialInfo.creditType"
								label={t("raFilling.financialInfo.form.label.creditType")}
								control={raFillingDataForm.control}
								fullWidth
								disabled
							/>
						</Grid>

						<Grid item xs={6} md={3}>
							<FormTextField<IRaFillingForm>
								name="financialInfo.paymentStatus"
								label={t("raFilling.financialInfo.form.label.paymentStatus")}
								control={raFillingDataForm.control}
								fullWidth
								disabled
							/>
						</Grid>

						<Grid item xs={6} md={3}>
							<FormTextField<IRaFillingForm>
								name="financialInfo.product"
								label={t("raFilling.financialInfo.form.label.product")}
								control={raFillingDataForm.control}
								fullWidth
								disabled
							/>
						</Grid>

						<Grid item xs={6} md={3}>
							<FormTextField<IRaFillingForm>
								name="financialInfo.businessAgreement"
								label={t("raFilling.financialInfo.form.label.businessAgreement")}
								control={raFillingDataForm.control}
								fullWidth
								disabled
							/>
						</Grid>

						<Grid item xs={6} md={3}>
							<FormAutocomplete<IRaFillingForm>
								name="financialInfo.clientPaymentCode"
								label={t("raFilling.financialInfo.form.label.firstBillingOwnerPaymentCode")}
								options={[]}
								getOptionLabel={(val: string) => translatePaymentCode(val)}
								control={raFillingDataForm.control}
								fullWidth
								disabled
							/>
						</Grid>

						<Grid item xs={6} md={3}>
							<FormAutocomplete<IRaFillingForm>
								name="financialInfo.driverPaymentCode"
								label={t("raFilling.financialInfo.form.label.secondBillingOwnerPaymentCode")}
								control={raFillingDataForm.control}
								options={[]}
								getOptionLabel={(val: string) => translatePaymentCode(val)}
								fullWidth
								disabled
							/>
						</Grid>

						<Grid item xs={6} md={3}>
							<FormTextField<IRaFillingForm>
								name="financialInfo.segment"
								label={t("raFilling.financialInfo.form.label.segment")}
								control={raFillingDataForm.control}
								fullWidth
								disabled
							/>
						</Grid>

						<Grid item xs={6} md={3}>
							<FormTextField<IRaFillingForm>
								name="financialInfo.category"
								label={t("raFilling.financialInfo.form.label.category")}
								control={raFillingDataForm.control}
								fullWidth
								disabled
							/>
						</Grid>
					</Grid>
				</AccordionDetails>
			</Accordion>
		</>
	)
}

export default FinancialInfo;
